import request from "./request";
import apis from "./apis";

const {
  archivedTranscript,
} = apis.archived;

const announcement = {
  getArchivedTranscript: (data: Object) => {
    return request.get(archivedTranscript, data);
  },
  updateArchivedTranscript: (data: Object) => {
    return request.post(archivedTranscript, data);
  },
};

export default announcement;